<template>
    <div class="container">
        <div class="first-row">
            Уровень
            <select v-model="form.level_id">
                <option v-for="level in levels" :value="level.id">
                    {{ level.name }}
                </option>
            </select>
            Название темы
            <input type="text" v-model="form.name">
        </div>
        <div>
            Описание укр
            <textarea cols="60" rows="7" v-model="form.description_ua"></textarea>
        </div>
        <div>
            Описание рус
            <textarea cols="60" rows="7" v-model="form.description"></textarea>
        </div>
        <div>
            Теоретическая часть укр
            <textarea cols="60" rows="7" v-model="form.theory_ua"></textarea>
        </div>
        <div>
            Теоретическая часть рус
            <textarea cols="60" rows="7" v-model="form.theory"></textarea>
        </div>
        <div>
            <input type="radio" name="status" value="0" v-model="form.status" checked> Черновик
            <input type="radio" name="status" value="1" v-model="form.status"> Опубликовать
        </div>
        <div class="text-danger" v-show="form.image !== ''" @click="removeImage">Удалить изображение</div>
        <img :src="form.image" alt="">
        <div>
            <input type="file" accept="image/*" @change="handleImage" ref="inputFile">
        </div>
        <hr>
        <div>
            <div>
                <span class="text-primary" @click="add">+ Создать финальный тест</span>
            </div>
            <div v-for="(question, qIndex) in form.questions" :key="qIndex">
                <div>
                    Задание {{ qIndex + 1 }}
                    <span class="text-danger" @click="remove(qIndex)" >Удалить задание</span>
                </div>
                <div>
                    Текст задания
                    <input type="text" class="col-5 m-2" v-model="question.question">
                </div>
                <div v-for="(option, key) in question.options">
                    Ответ {{ key + 1}}
                    <input type="text" class="col-6 m-2" v-model="question.options[key]">
                    <div v-if="typeof question.rightAnswer !== 'object'" class="d-inline">
                        <input type="radio" :name="'answer' + Math.random().toString(5)" :value="key + 1" v-model="question.rightAnswer">
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button @click="create">Сохранить</button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    "name": "CreateTheme",
    computed: {
        ...mapState({
            levels: state => state.levels.levels,
        })
    },
    data() {
        return {
            form: {
                level_id: 1,
                name: '',
                description_ua: '',
                description: '',
                theory_ua: '',
                theory: '',
                image: '',
                status: 0,
                questions: [],
            },
        }
    },
    methods: {
        create() {
            let tmpImage = this.form.image;
            this.form.image = this.form.image.split(',')[1];
            this.createTheme(this.form);
            this.form.image = tmpImage;
        },
        ...mapActions({
           'createTheme': 'themes/createTheme',
            'getLevels': 'levels/getLevels',
        }),
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.createBase64Image(selectedImage);
        },
        createBase64Image(file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.form.image = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage() {
            this.form.image = '';
            this.$refs.inputFile.value = null;
        },
        add() {
            this.form.questions.push({
                type: 9,
                question: '',
                options: ['','','',''],
                rightAnswer: 1,
            });
        },
        remove(qNumber) {
            this.form.questions.splice(qNumber, 1)
        },
    },
    mounted() {
        this.getLevels()
    }
}
</script>

<style scoped>
.first-row {
    margin-bottom: 40px;
}
</style>